/**
 * FoundingChapterBand (iter 137)
 *
 * Homepage social-proof band, honest early-stage framing. Replaces the
 * previous "Founding Partner / Coming soon" placeholder tile grid + fake
 * testimonials. Two CTAs — the existing employer + talent signup pages
 * (unchanged routes).
 *
 * Copy rules baked in:
 *   • No numeric claims (no counts of passports, employers, days-to-hire).
 *   • No named customer logos or testimonials.
 *   • US-wide with California focus — never LA-only.
 *   • Composes with the existing line "Founding employers are currently
 *     being invited to join Simonara." rendered elsewhere.
 */
import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Sparkles, ArrowRight, Building2, IdCard } from "lucide-react";

const FoundingChapterBand = () => (
    <section className="section-pad" data-testid="home-founding-chapter">
        <div className="container-page">
            <motion.div
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.4 }}
                className="max-w-3xl mx-auto text-center"
            >
                <p className="overline inline-flex items-center gap-1.5">
                    <Sparkles size={11} /> Our founding chapter
                </p>
                <h2 className="mt-3 font-heading font-semibold text-3xl sm:text-4xl tracking-tight text-foreground">
                    Simonara is just getting started — join us at the beginning.
                </h2>
                <p className="mt-4 text-muted-foreground text-base sm:text-lg">
                    Founding employers are currently being invited to join. Talent founding members can build a verified profile for free.
                </p>
                <p className="mt-2 text-muted-foreground text-sm">
                    Serving US employers and professionals nationwide.
                </p>

                <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
                    <Link
                        to="/employers/signup"
                        className="inline-flex items-center gap-1.5 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold px-5 py-3 transition"
                        data-testid="founding-chapter-employer-cta"
                    >
                        <Building2 size={14} /> Request a founding employer invite <ArrowRight size={14} />
                    </Link>
                    <Link
                        to="/talent/signup"
                        className="inline-flex items-center gap-1.5 rounded-full border border-border hover:bg-muted text-foreground text-sm font-semibold px-5 py-3 transition"
                        data-testid="founding-chapter-talent-cta"
                    >
                        <IdCard size={14} /> Become a founding talent member <ArrowRight size={14} />
                    </Link>
                </div>
            </motion.div>
        </div>
    </section>
);

export default FoundingChapterBand;
